// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-1adcac79]{display:none}.empty-result[data-v-1adcac79]{display:flex;flex-direction:column;min-height:50vh;justify-content:center;text-align:center;align-items:center;margin:10px 0}@media(max-width:1023px){.empty-result[data-v-1adcac79]{min-height:10vh}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
